        <div class="flex flex-col gap-4 md:w-[30rem]" data-testid="impersonate-unavailable">
            <div class="flex items-start gap-3 rounded-border p-4 bg-surface-100 dark:bg-surface-800">
                <i class="pi pi-info-circle text-xl text-surface-600 dark:text-surface-300" aria-hidden="true"></i>
                <div>
                    <div class="font-medium text-surface-900 dark:text-surface-0">Impersonation is not available yet.</div>
                    <p class="text-muted-color mt-1 mb-0">It has been turned off while a secure version is designed.</p>
                </div>
            </div>
            <div>
                <p-button label="Impersonate" icon="pi pi-user" [disabled]="true" ariaLabel="Impersonate (not available)"></p-button>
            </div>
        </div>
